import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Projects from './pages/Projects';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Doctors from './pages/Doctors';
import DoctorDetail from './pages/DoctorDetail';
import Contact from './pages/Contact';
import PillDetail from './pages/PillDetail';
import { Toaster } from './components/ui/toaster';
import { AuthProvider } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import ManageServices from './pages/admin/ManageServices';
import ManageProjects from './pages/admin/ManageProjects';
import ManageBlog from './pages/admin/ManageBlog';
import ManageDoctors from './pages/admin/ManageDoctors';
import ManageTimeline from './pages/admin/ManageTimeline';
import ManagePills from './pages/admin/ManagePills';
import ManageContacts from './pages/admin/ManageContacts';
import ManageChats from './pages/admin/ManageChats';
import ManageSettings from './pages/admin/ManageSettings';

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Public site */}
              <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="haqqimda" element={<About />} />
                <Route path="xidmetler" element={<Services />} />
                <Route path="xidmetler/:id" element={<ServiceDetail />} />
                <Route path="layiheler" element={<Projects />} />
                <Route path="bloq" element={<Blog />} />
                <Route path="bloq/:id" element={<BlogDetail />} />
                <Route path="hekimler" element={<Doctors />} />
                <Route path="hekimler/:id" element={<DoctorDetail />} />
                <Route path="elaqe" element={<Contact />} />
                <Route path="pills/:id" element={<PillDetail />} />
              </Route>
              {/* Admin (hidden path) */}
              <Route path="/panel-abbasov" element={<AdminLogin />} />
              <Route path="/panel-abbasov" element={<AdminLayout />}>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="services" element={<ManageServices />} />
                <Route path="projects" element={<ManageProjects />} />
                <Route path="blog" element={<ManageBlog />} />
                <Route path="doctors" element={<ManageDoctors />} />
                <Route path="timeline" element={<ManageTimeline />} />
                <Route path="pills" element={<ManagePills />} />
                <Route path="contacts" element={<ManageContacts />} />
                <Route path="chats" element={<ManageChats />} />
                <Route path="settings" element={<ManageSettings />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </SettingsProvider>
      <Toaster />
    </div>
  );
}

export default App;
